import { useState, useMemo } from "react";
import { toast } from "react-toastify";
import ButtonSpinner from "src/components/Loader/ButtonSpinner";
import useGetPrices from "src/hooks/useGetPrices";
import { useClientSignUpSteps } from "src/lib/store/hirer-steps-store";
import StepLayout from "../layout";
import SelectRole from "./roles";
import NewSpecialty from "./specialty/NewSpecialty";
import SelectSkills from "./skills";
import SelectSpecialty from "./specialty";
import SelectTools from "./tools";
import SelectType from "./type";
import NewTool from "./tools/NewTool";

export default function HirerRequirementStep({
  handleClick,
  steps,
  close,
}) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { loading: pricesLoading, error: priceError, prices, workType } = useGetPrices();
  const { userStack, userLanguages, userFrameworks, userLevel, userSkills, updateUserLevel, updateWorkType, userJobType } = useClientSignUpSteps();
  const [selectedWorkType, setSelectedWorkType] = useState("");

  
  
  const techLevels = ['junior', 'mid', 'senior'];


  const handleSubmit = (event) => {
    if (!userStack) {
      return toast.error('Select role')
    }

    if (userLanguages?.length === 0) {
      return toast.error('Select specialty')
    }

    if (userFrameworks?.length === 0) {
      return toast.error('Select tools')
    }

    /* `userLevel` is the selected price row, not a list: it starts out
       `undefined`, so `userLevel?.length === 0` was never true and a request
       could be posted with no level at all. */
    if (!userLevel?.seniority) {
      return toast.error('Select level')
    }

    if (userSkills?.length === 0) {
      return toast.error('Select skills')
    }

    handleClick("next");
  };

  const filteredPrices = useMemo(() => {
    if (userJobType === 'tech') {
      return prices.filter(p => [1, 2, 3, 4].includes(p.id));
    }
    if (userJobType === 'non-tech') {
      return prices.filter(p => [1, 5, 6, 7].includes(p.id));
    }
    return prices;
  }, [prices, userJobType]);

  const handleLevelSelect = (event) => {
    const value = event.target.value;

    if (value?.toLowerCase() !== "select") {
      const level = prices.find(each => each.id === +value)
      updateUserLevel(level);
    }
  };

  const handleWorkTypeSelect = (e) => {
     const value  =  e.target.value

    if(value?.toLowerCase() !== 'select')  {
      const work  =  workType.find(each => each.id === +value)
 updateWorkType(work)
    }

};



  return (
    <>
      <StepLayout
        title="Hire Request Specification"
        description="What role are you hiring for?"
        extraArea={
          userFrameworks?.length > 0 && (
            <div className="flex flex-col gap-2 space-y-4">

              <div className="flex flex-col gap-2">
                <label htmlFor="#level">Select Level</label>
                <select
                  onChange={handleLevelSelect}
                  className="bg-white border-gray-400 border-b-2 p-2 capitalize open:bg-red"
                >
                  <option value={""}>Select</option>
                  {filteredPrices.map((level, index) => {
                    return (
                      <option
                        key={index}
                        value={level.id}
                        className="capitalize"
                      >
                        {level.seniority}
                      </option>
                    );
                  })}
                </select>
              </div>



{/* Slect work  type */}
                 <div className="hidden flex-col gap-2">
                <label htmlFor="#level">Select Work Type</label>
                <select
                 onChange={handleWorkTypeSelect}
                  className="bg-white border-gray-400 border-b-2 p-2 capitalize open:bg-red"
                >
                  <option value={""}>Select</option>
                  {workType.map((work, index) => {
                    return (
                      <option
                        key={index}
                        value={work.id}
                        className="capitalize"
                      >
                        {work.title}
                      </option>
                    );
                  })}
                </select>
              </div>

              <SelectSkills />
            </div>
          )
        }
      >
        <>
 { <SelectType />}

{userJobType === 'tech' && <SelectRole />}

{userJobType === 'tech' && !!userStack && (
  <SelectSpecialty />
)}

{userJobType === 'tech' && !!userStack && !!userLanguages && (
  <SelectTools />
)}

{userJobType === 'non-tech' && <NewSpecialty />}

{userJobType === 'non-tech' && !!userLanguages?.length && <NewTool />}
          {/* {userLanguages?.length > 0 && (
            <SelectTools />
          )} */}
        </>
      </StepLayout>

      <div className="mt-8 flex justify-between">
        <button
          onClick={close}
          type="button"
          className={
            "bg-surface hover:bg-gray-200 rounded-md p-3 cursor-pointer"
          }
        >
          Cancel
        </button>

        <button
          onClick={handleSubmit}
          disabled={isSubmitting}
          className="flex items-center bg-primary text-white rounded-md px-4 cursor-pointer"
        >
          Next
          {isSubmitting && <ButtonSpinner />}
        </button>
      </div>
    </>
  );
}

